import { type FunctionComponent, useCallback, useEffect } from 'react';
import {
  TextareaComposer,
  useMessageComposer,
  useMessageComposerHasSendableData,
  useMessageInputContext,
  useTranslationContext,
} from 'stream-chat-react';
import { Button } from '../../../atoms/Button/Button';
import styles from './EditMessageForm.module.css';

export type EditMessageFormProps = {};

export const EditMessageForm: FunctionComponent<EditMessageFormProps> = () => {
  const { t } = useTranslationContext();
  const messageComposer = useMessageComposer();
  const { clearEditingState, handleSubmit } = useMessageInputContext();
  const hasSendableData = useMessageComposerHasSendableData();

  const onCancel = useCallback(() => {
    clearEditingState?.();
    messageComposer.restore();
  }, [clearEditingState, messageComposer]);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onCancel();
      }
    };
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onCancel]);

  return (
    <div className={styles.root}>
      <TextareaComposer />
      <div className={styles.buttons}>
        <Button intent="secondary" onClick={onCancel} type="button">
          {t('Cancel')}
        </Button>
        <Button disabled={!hasSendableData} onClick={handleSubmit}>
          {t('Send')}
        </Button>
      </div>
    </div>
  );
};
